import { z } from "zod";

export const DischargeLetterErHandoverFormSchema = z.object({
  admission_medications: z.string().optional(),
  admission_reason: z.string().optional(),
  allergies: z.string().optional(),
  anamnesis: z.string().optional(),
  diagnoses: z.string().optional(),
  discharge_medications: z.string().optional(),
  lab_results: z.string().optional(),
  parameters: z.string().optional(),
  recommendations: z.string().optional(),
  therapy: z.string().optional(),
});
